export default __webpack_public_path__ + "static/media/License & Disclaimer .81bbce85.pdf";